/* AD-10 · LAUNCH GATES
   ADM-14/24/38/42/47: regulated-industry gate, sector-kit registry, data-rights
   SLA, tax/invoice readiness, company continuity — nothing launches around an
   unresolved gate. · Bible §66–67 */
import { ListRow } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD10LaunchGates() {
  const rows = useAdmin().gates
  return (
    <section data-frame="AD-10" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Portes de lancement</h2>
      <div>
        {rows.map(r => (
          <ListRow key={r.title} title={r.title} meta={r.meta} end={<Mark cell={r.mark} />} />
        ))}
      </div>
    </section>
  )
}
